Application.Signature.Contact = {
    ui: {
        container: '.js-signature-contact.step-contact',
        control: '.step-contact .form-control__input, .step-contact .form-checkbox__input, .step-contact .full-form__input',
        inputs: {
            width: '.step-contact__width-input',
        },
        preview: {
            content: '.preview__content',
            inner: '.preview__signature-container'
        },
        signature: {
            container: '.step-contact .email-signature',
            contents: '.email-signature__contents',
            placeholder: '.email-signature__placeholder',
            banner: '.email-signature__banner',
            impressum: '.email-signature__impressum'
        },
        select: {
            container: '.form-control_select',
            select: '.form-control__input',
            input: '.form-control__sync-hidden',
        }
    },
    ready: function () {

        if (!$(this.ui.container).length){
            return;
        }

        this.bind();

        // update state
        this.updatePreview();
        this.updatePreviewState();
        this.updateInputs();

        // set as ready
        $(this.ui.container).removeClass('step-preview_loading');

    },
    bind: function(){

        var self = this;

        // sync select input
        $(document).on('change', this.ui.select.select, function(event){
            self.updateCountrySelect(this);
        });

        // sync preview
        $(document).on('change keyup', this.ui.control, function(event){
            self.updatePreview();
            self.updateInputs();
        });

    },
    updateCountrySelect: function(select){

        var $select = $(select);
        var $input = $select.closest(this.ui.select.container).find(this.ui.select.input);

        $input.val($select.val());

    },
    updatePreview: function(){

        var $container = $(this.ui.container);
        var $signature = $(this.ui.signature.container);

        // retrieve values
        var fullName = $container.find('input[name="full_name"]').val();
        var jobTitle = $container.find('input[name="job"]').val();
        var mobilePhone = $container.find('input[name="mobile_phone"]').val();
        var fixedPhone = $container.find('input[name="fixed_phone"]').val();
        var email = $container.find('input[name="email"]').val();
        var country = $container.find('input[name="country"]').val();
        var linkedin = $container.find('input[name="linkedin"]').val();
        var bannerEnabled = $container.find('input[name="banner_enabled"]').is(':checked');
        var bannerId = $container.find('input[name="banner_id"]').val();
        var banner = bannerEnabled ? banners[bannerId] : null;
        var qrCodeEnabled = $container.find('input[name="qr_code_enabled"]').is(':checked');
        var qrCodeColorId = $container.find('input[name="qr_code_color_id"]').val();
        var qrCode = qrCodeEnabled ? qrCodeColors[qrCodeColorId] : null;

        // render
        $signature.find('.email-signature__name').text(fullName);
        $signature.find('.email-signature__job-title').text(jobTitle);
        $signature.find('.email-signature__address-1').text(typeof countries[country] !== 'undefined' ? countries[country].address[0] : '');
        $signature.find('.email-signature__address-2').text(typeof countries[country] !== 'undefined' ? countries[country].address[1] : '');
        $signature.find('.email-signature__address-3').text((typeof countries[country] !== 'undefined' && typeof countries[country].address[2] !== 'undefined') ? countries[country].address[2] : '');
        $signature.find('.email-signature__impressum').html((typeof countries[country] !== 'undefined' && countries[country].impressum) ? countries[country].impressum.replace(/\n/g, '<br>') : '');

        // phones
        $signature.find('.email-signature__mobile-phone').text(mobilePhone);
        $signature.find('.email-signature__fixed-phone').text(fixedPhone);
        if (fixedPhone){
            $signature.find('.email-signature__fixed-phone-container').show();
        }else{
            $signature.find('.email-signature__fixed-phone-container').hide();
        }

        // linkedin
        $signature.find('.email-signature__user-linkedin').attr('href', linkedin);
        if (linkedin){
            $signature.find('.email-signature__user-linkedin-container').show();
        }else{
            $signature.find('.email-signature__user-linkedin-container').hide();
        }

        // facebook
        var facebook = (typeof countries[country] !== 'undefined' && typeof countries[country].social['facebook'] !== 'undefined') ? countries[country].social['facebook'] : false;
        if (facebook){
            $signature.find('.email-signature__facebook-container').show();
            $signature.find('.email-signature__facebook').attr('href', facebook);
        }else{
            $signature.find('.email-signature__facebook-container').hide();
            $signature.find('.email-signature__facebook').attr('href', facebook);
        }
        // twitter
        var twitter = (typeof countries[country] !== 'undefined' && typeof countries[country].social['twitter'] !== 'undefined') ? countries[country].social['twitter'] : false;
        if (twitter){
            $signature.find('.email-signature__twitter-container').show();
            $signature.find('.email-signature__twitter').attr('href', twitter);
        }else{
            $signature.find('.email-signature__twitter-container').hide();
            $signature.find('.email-signature__twitter').attr('href', twitter);
        }
        // instagram
        var instagram = (typeof countries[country] !== 'undefined' && typeof countries[country].social['instagram'] !== 'undefined') ? countries[country].social['instagram'] : false;
        if (instagram){
            $signature.find('.email-signature__instagram-container').show();
            $signature.find('.email-signature__instagram').attr('href', instagram);
        }else{
            $signature.find('.email-signature__instagram-container').hide();
            $signature.find('.email-signature__instagram').attr('href', instagram);
        }
        // youtube
        var youtube = (typeof countries[country] !== 'undefined' && typeof countries[country].social['youtube'] !== 'undefined') ? countries[country].social['youtube'] : false;
        if (youtube){
            $signature.find('.email-signature__youtube-container').show();
            $signature.find('.email-signature__youtube').attr('href', youtube);
        }else{
            $signature.find('.email-signature__youtube-container').hide();
            $signature.find('.email-signature__youtube').attr('href', youtube);
        }
        // linkedin
        var linkedin = (typeof countries[country] !== 'undefined' && typeof countries[country].social['linkedin'] !== 'undefined') ? countries[country].social['linkedin'] : false;
        if (linkedin){
            $signature.find('.email-signature__linkedin-container').show();
            $signature.find('.email-signature__linkedin').attr('href', linkedin);
        }else{
            $signature.find('.email-signature__linkedin-container').hide();
            $signature.find('.email-signature__linkedin').attr('href', linkedin);
        }
        // pinterest
        var pinterest = (typeof countries[country] !== 'undefined' && typeof countries[country].social['pinterest'] !== 'undefined') ? countries[country].social['pinterest'] : false;
        if (pinterest){
            $signature.find('.email-signature__pinterest-container').show();
            $signature.find('.email-signature__pinterest').attr('href', pinterest);
        }else{
            $signature.find('.email-signature__pinterest-container').hide();
            $signature.find('.email-signature__pinterest').attr('href', pinterest);
        }
        // soundscapes
        var soundscapes = (typeof countries[country] !== 'undefined' && typeof countries[country].social['soundscapes'] !== 'undefined') ? countries[country].social['soundscapes'] : false;
        if (soundscapes){
            $signature.find('.email-signature__soundscapes-container').show();
            $signature.find('.email-signature__soundscapes').attr('href', soundscapes);
        }else{
            $signature.find('.email-signature__soundscapes-container').hide();
            $signature.find('.email-signature__soundscapes').attr('href', soundscapes);
        }

        // banner
        $signature.find('.email-signature__banner').empty();
        if (banner && banner.active && !banner.deleted && banner.countries && _.contains(banner.countries, country)){
            var $bannerImg = $('<img />').attr('src', baseUrl + '/data/banners/' + banner.src)
                                         .attr('width', banner.width)
                                         .attr('height', banner.height)
                                         .css({
                                             width: banner.width,
                                             height: banner.height,
                                         });
            var $bannerA = $('<a href="#" target="_blank" />').append($bannerImg);
            $signature.find('.email-signature__banner').append('<br /><br />').append(banner.href ? $bannerA : $bannerImg);
        }

        // QR code
        var $qrCodePlaceholder = $signature.find('.email-signature__qr-code');
        $qrCodePlaceholder.empty();
        if (qrCode){
            var qrCodeTemplate = $('#template-qr-code').html();
            $qrCodePlaceholder.html(qrCodeTemplate);
            $qrCodePlaceholder.find('.email-signature__qr-code-image').attr('src', baseUrl + '/data/qr-code-colors/thumbnail/signature-preview/' + qrCode.id + '.png');
        }

        // scale
        this.rescale();

        // update state
        this.updatePreviewState();

    },
    updateInputs: function(){

        // calculate width
        var contentsWidth = $(this.ui.signature.contents).width();
        $(this.ui.inputs.width).val(contentsWidth);

    },
    rescale: function(){

        var paddingX = 25;
        var previewWidth = $(this.ui.preview.content).outerWidth() - 2 * paddingX;
        var signatureWidth = $(this.ui.signature.container).outerWidth();
        var paddingY = 50;
        var previewHeight = $(this.ui.preview.content).outerHeight() - 2 * paddingY;
        var signatureHeight = $(this.ui.signature.container).outerHeight();

        var ratioX = previewWidth < signatureWidth ? previewWidth / signatureWidth : 1;
        var ratioY = previewHeight < signatureHeight ? previewHeight / signatureHeight : 1;
        var ratio = ratioX > ratioY ? ratioY : ratioX;
        $(this.ui.preview.inner).css('transform', 'translate(-50%, -50%) scale(' + ratio + ')');

    },
    updatePreviewState: function(){

        var $placeholders = $(this.ui.signature.placeholder);

        $placeholders.each(function(){
            $(this).toggleClass('email-signature__placeholder_empty', !$(this).text());
        });

    }
}